<script>
	/**
	 * 입력 한 줄 — **왼쪽 이름표(고정 폭) · 오른쪽 입력 · 그 아래 도움말**. [레시피] 탭 공용.
	 *
	 * ⚠️ 예전엔 칸마다 이름표 폭이 제각각이었다(w-24 / pl-[108px] / grid 96px / 120px) — 입력칸의
	 *    왼쪽 선이 들쭉날쭉해서 무엇이 무엇의 설명인지 읽기 어려웠다. 이 한 곳에서 폭을 정한다.
	 * ⚠️ 도움말은 `slot="hint"` 로 — 굵은 글씨·코드가 섞이므로 문자열 prop 으로는 못 담는다.
	 * ⚠️ 좁은 화면에서는 위아래로 쌓는다(이름표가 입력칸을 밀어내지 않게).
	 */
	export let label = "";
	/** 여러 줄 입력이면 이름표를 위로 붙인다(가운데 정렬이면 이름표가 공중에 뜬다). */
	export let top = false;
</script>

<div class="row" class:top>
	<div class="lbl">{label}</div>
	<div class="ctl">
		<slot />
		{#if $$slots.hint}<div class="hint"><slot name="hint" /></div>{/if}
	</div>
</div>

<style>
	/* ⚠️ 이름표는 **입력칸 첫 줄(40px)** 가운데에 맞춘다. 줄 전체 가운데로 두면 도움말이 붙은 줄에서
	 *    이름표가 (입력+도움말) 가운데로 내려가 입력칸과 어긋난다. 스위치처럼 낮은 입력은 호출부가
	 *    40px 칸(tw-min-h-10)에 담아 같은 선에 세운다. */
	.row {
		display: grid;
		grid-template-columns: 112px minmax(0, 1fr);
		column-gap: 12px;
		align-items: start;
	}
	.lbl {
		min-height: 40px;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: 600;
		color: hsl(var(--sb-foreground));
	}
	/* 여러 줄 입력은 이름표를 첫 줄 높이에 둔다(가운데면 공중에 뜬다). */
	.row.top .lbl {
		align-items: flex-start;
		padding-top: 10px;
	}
	.ctl {
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.hint {
		font-size: 12px;
		line-height: 1.5;
		color: hsl(var(--sb-muted-foreground));
	}
	@media (max-width: 640px) {
		.row {
			grid-template-columns: minmax(0, 1fr);
			row-gap: 4px;
		}
		.lbl,
		.row.top .lbl {
			min-height: 0;
			padding-top: 0;
		}
	}
</style>
